import { render } from "./OHou.vue?vue&type=template&id=08f7cdce&bindings={}"
import script from "./OHou.vue?vue&type=script&lang=ts"
export * from "./OHou.vue?vue&type=script&lang=ts"

import "./OHou.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script